<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">Etwas ist schief gelaufen.</h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !internalServerError" class="contents-wrapper">
    <div class="contents-container">
      <app-zaver-icon class="icon-user-img" [size]="80" name="bankSignalCircle" ></app-zaver-icon>

      <h1 class="heading">Identitäts- und Bonitätsprüfung</h1>

      <p class="info-text">
        Im nächsten Schritt bitten wir Sie, sich per Online-Banking anzumelden,
        damit Zaver (Frink&nbsp;AB) Ihre Identität und Bonität prüfen kann.
      </p>
      <p class="sub-info-text">
        Dieser Schritt ist notwendig, um Ihnen die gewählte
        Zahlungsart&nbsp;zu&nbsp;gewähren.
      </p>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="button-container">
            <zaver-primary-button
              text="{{ showOnboardingText ? 'Bestätigen' : 'Weiter' }}"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
